import * as Account from 'app/react/entities/accounts/helpers';
import * as Event from 'app/react/entities/events/helpers';
import * as Booking from 'app/react/entities/events/bookings/helpers';
import * as Schemas from './schemas'
import {
    getEntitiesCollectionByKey,
    getSomeEntities,
} from 'app/react/state/helpers';
import {
    generateCollectionKey,
} from './reducers';

const {
    ENTITY_REDUCER_KEY,
    COLLECTION_REDUCER_KEY
} = Schemas;

export const getAll = (state, accountId, eventId, bookingId) => {
    const collection = getCollection(state, accountId, eventId, bookingId);
    return getSomeEntities(state, ENTITY_REDUCER_KEY, collection.ids);
};

export const getCollection = (state, accountId, eventId, bookingId) => {
    const key = generateCollectionKey(accountId, eventId, bookingId);
    return getEntitiesCollectionByKey(state, COLLECTION_REDUCER_KEY, key);
};

export const getCollectionForCurrentContext = (state) => {
    const accountId = Account.getCurrentId(state);
    const eventId = Event.getCurrentId(state);
    const bookingId = Booking.getCurrentId(state);
    return getCollection(state, accountId, eventId, bookingId);
};

export const getAllForCurrentContext = (state) => {
    const collection = getCollectionForCurrentContext(state);
    return getSomeEntities(state, ENTITY_REDUCER_KEY, collection.ids);
};

export const isFetchingAllForCurrentContext = (state) => {
    const collection = getCollectionForCurrentContext(state);
    return !! collection.isFetching
};

export const mixins = (state) => ({
    [ENTITY_REDUCER_KEY]: {
        isFetchingAllForCurrentContext: () =>
            isFetchingAllForCurrentContext(state),
        getAllForCurrentContext: () =>
            getAllForCurrentContext(state),
    }
});
